import { Descendant } from 'slate';

import { internalKey } from '../constants';

// models
import { ElementKind, SectionType } from '../../../models/editor.model';
import {
    SurfaceButtonFieldLabel,
    SurfaceTemplateComponentTypes,
    TemplateComponentInternalStructure,
} from '../../../models/surface.model';

export const isMultiOrSingleLineInput = (
    inputType: SurfaceTemplateComponentTypes,
) => {
    return [
        SurfaceTemplateComponentTypes.SingleLine,
        SurfaceTemplateComponentTypes.MultiLine,
    ].includes(inputType);
};

export const getStructureFromSchema = (
    surfaceSchema: TemplateComponentInternalStructure,
): Descendant[] => {
    const keys = Object.keys(surfaceSchema).filter(
        (key) => key !== internalKey,
    );
    // sort as per order
    keys.sort((a, b) => {
        return (
            surfaceSchema[a]._internal.order - surfaceSchema[b]._internal.order
        );
    });

    const structure = keys.map((key) => {
        const inputType = surfaceSchema[key]._internal.type;
        let element: any = {};

        // setting kind
        element['kind'] = isMultiOrSingleLineInput(inputType)
            ? ElementKind.section
            : [SurfaceTemplateComponentTypes.Image].includes(inputType)
            ? ElementKind.image
            : ElementKind.surfaceButton;

        // setting sectionType
        if (isMultiOrSingleLineInput(inputType)) {
            element['sectionType'] =
                inputType === SurfaceTemplateComponentTypes.SingleLine
                    ? SectionType.single_line_input
                    : SectionType.multi_line_input;
        }

        // setting children
        if (inputType === SurfaceTemplateComponentTypes.Button) {
            element['children'] = [
                {
                    kind: ElementKind.section,
                    surfaceFieldName: SurfaceButtonFieldLabel.Text,
                    surfaceFieldType: SurfaceTemplateComponentTypes.SingleLine,
                    children: [{ text: '' }],
                    sectionType: SectionType.surface_button_text,
                },
                {
                    kind: ElementKind.section,
                    surfaceFieldName: SurfaceButtonFieldLabel.Action,
                    surfaceFieldType: SurfaceTemplateComponentTypes.SingleLine,
                    children: [{ text: '' }],
                    sectionType: SectionType.surface_button_action,
                },
            ];
        } else {
            element['children'] = [{ text: '' }];
        }

        element['surfaceFieldName'] = key;
        element['surfaceFieldLabel'] = surfaceSchema[key]._internal.fieldName;
        element['surfaceFieldType'] = inputType;
        return element as Descendant;
    });
    return structure;
};
